/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators/tap';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map'
import { XmlparseService } from '../xml/xmlparse.service';
import { Iceutility } from '../iceutility';
import { patientindex } from '../../models/domain/patientindex';

import { AlertService } from "../../services/alert/alert.service";
import { LoginService } from '../../login/login.service';

declare var require: any;

@Injectable()
export class PatientKioskService extends XmlparseService {

  constructor(private http: HttpClient, private alertSvc: AlertService, private loginSvc: LoginService) {
      super(alertSvc, loginSvc);
    }

    public searchPatient(value): Observable<any> {
        let currentEnv: any = require("../../../../../env.json").currentEnv;
        let envs: any = require("../../../../../env.json").environments;
        if (!envs) throw "Login service is not configured.";

        let url = envs[currentEnv].icemedx_api + "/patients/default.aspx?domain=&data=&providerdomain=patient&key=&subkeys=keywordtype:;domaintype:;keywords:" + value + ";";
        return this.http.get(url, { responseType: 'text' }).pipe(
            tap(
                data => this.parseLogReport(url, data),
                error => this.parseLogReport(url, error)
            )).map(response => this.parsePatientDetails(response));
    }

    public getAllProviders(): Observable<any> {
        let currentEnv: any = require("../../../../../env.json").currentEnv;
        let envs: any = require("../../../../../env.json").environments;
        if (!envs) throw "Login service is not configured.";

        let url = envs[currentEnv].icemedx_api + "/providers/default.aspx?domain=&data=profile";
        return this.http.get(url, { responseType: 'text' }).pipe(
            tap(
                data => this.parseLogReport(url, data),
                error => this.parseLogReport(url, error)
            )).map(response => this.parseProviderDetails(response));

    }

    public insertPatient(patient): Observable<any> {
        let currentEnv: any = require("../../../../../env.json").currentEnv;
        let envs: any = require("../../../../../env.json").environments;
        if (!envs) throw "PT Kiosk service is not configured.";
        if (!Iceutility.isdefined(patient)) throw "Invalid message.";

        let tblname = patient.gettablename().toLowerCase();
        let data = "{" + JSON.stringify(tblname) + ": " + JSON.stringify(patient) + "}";

        let url = envs[envs.currentEnv].icemedx_api + "/api/patients?domain=&data=adddemo&providerdomain=&key=&subkeys=domaintype:patient;lastname:" + patient.lastname;

        return this.http.post(url, patient, { responseType: 'text' }).pipe(
            tap(
                data => this.parseLogReport(url, data),
                error => this.parseLogReport(url, error)
            )).map(
                response => this.parsePatientDetails(response));
    }

    private parsePatientDetails(prvData: any) {
        let results = this.geticexdocumentobjects(prvData, ["PATIENT_INDEX"]);
        if (results && results.length > 0) {
            results = results[0];
            results["dob"] = Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(results["dob"]));
        }
        return results;
    }

    private parseProviderDetails(prvData: any) {
        let results = this.geticexdocumentobjects(prvData, ["PROVIDER_INDEX"]);
        return results;
    }

}
